import { FC } from "react";
import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { ListAlt as ListAltIcon } from "@mui/icons-material";
import { canUseOnboardingRequests } from "../../../../auth/permissions";
import { useRoles } from "../../../../auth/useRoles";

export const RequestNewCounterpartyMenu: FC = () => {
  const roles = useRoles();
  const showOnboardingRequests = canUseOnboardingRequests(roles);

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 2
      }}
    >
      <Typography sx={{ marginLeft: 1 }} variant="h5" component="span">
        Request onboarding of a new counterparty
      </Typography>
      {showOnboardingRequests && (
        <Link to="/tradingcounterparties/my-requests">
          <Button variant="outlined" startIcon={<ListAltIcon />}>
            My requests
          </Button>
        </Link>
      )}
    </Box>
  );
};
